import React, { Component } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import { BrowserRouter as Router } from "react-router-dom";
import AlertPnl from "../../assets/components/panel/AlertPnl";
import TopBar from '../../assets/components/topbar/TopBar';
import logo from '../../images/public/login/logo.png';
import clos from '../../images/public/registeration/clos.png';
import { changePhoneNumber } from '../../libs/fetch';
import tr from '../../libs/tr';
import './ChangePhone.css';

let user;

// Lista dei prefissi internazionali più comuni
const countryCodes = [
  { code: '+39', country: 'Italia' },
  { code: '+1', country: 'USA/Canada' },
  { code: '+44', country: 'Regno Unito' },
  { code: '+33', country: 'Francia' },
  { code: '+49', country: 'Germania' },
  { code: '+34', country: 'Spagna' },
  { code: '+41', country: 'Svizzera' },
  { code: '+43', country: 'Austria' },
  { code: '+32', country: 'Belgio' },
  { code: '+31', country: 'Paesi Bassi' },
  { code: '+351', country: 'Portogallo' },
  { code: '+30', country: 'Grecia' },
  { code: '+353', country: 'Irlanda' },
  { code: '+45', country: 'Danimarca' },
  { code: '+46', country: 'Svezia' },
  { code: '+47', country: 'Norvegia' },
  { code: '+358', country: 'Finlandia' },
  { code: '+48', country: 'Polonia' },
  { code: '+420', country: 'Repubblica Ceca' },
  { code: '+36', country: 'Ungheria' },
  { code: '+40', country: 'Romania' },
  { code: '+7', country: 'Russia' },
  { code: '+86', country: 'Cina' },
  { code: '+81', country: 'Giappone' },
  { code: '+82', country: 'Corea del Sud' },
  { code: '+91', country: 'India' },
  { code: '+55', country: 'Brasile' },
  { code: '+54', country: 'Argentina' },
  { code: '+52', country: 'Messico' },
  { code: '+61', country: 'Australia' },
  { code: '+64', country: 'Nuova Zelanda' },
  { code: '+27', country: 'Sudafrica' },
  { code: '+20', country: 'Egitto' },
  { code: '+971', country: 'Emirati Arabi' },
  { code: '+966', country: 'Arabia Saudita' },
  { code: '+90', country: 'Turchia' },
];

class ChangePhone extends Component {
  constructor(props) {
    super(props);

    //let params = null;
    this.state = {
      step: '1',
      phone: '',
      phoneCode: '+39', // Default impostato a +39 per Italia
      oldemail: '',
      userInfo: null,
      phoneErr: false,
      backto: null,
    };

    this.handleChangePhone = this.handleChangePhone.bind(this);
    this.savePhoneNumber = this.savePhoneNumber.bind(this);
  }


  /* Life Cycle*/
  componentDidMount = () => {

    if (!localStorage.getItem('user')) {
      return this.props.history.push('/');
    }

    user = JSON.parse(localStorage.getItem('user'));
    let backto = localStorage.getItem('backto');
    this.setState({ backto });
  }

  canBeSubmitted = () => {
    return (!this.state.phoneErr && this.state.phone !== '');
  }

  savePhoneNumber = (e) => {

    e.preventDefault();
    if (this.canBeSubmitted()) {
      try {
        let user = JSON.parse(localStorage.getItem('user'));
        const phone = this.state.phoneCode + this.state.phone;
        changePhoneNumber(this, phone, user.email).then((response) => {

          if (response.status === "fail") {
            this.handleAlert(response.message);
            this.setState({ phoneErr: true })
          }
          if (response.status === "success") {
            user.phone = phone;
            user.tel_cell = phone;
            localStorage.setItem('user', JSON.stringify(user));

            this.props.history.push({
              pathname: '/confirm-phone'
            });

          }
        });

      } catch (error) {

        // alert(error)
        this.handleAlert(error);
      }
    }
    else {
      this.setState({ phoneErr: true })
    }

    return
  }

  handleChangePhone = (e) => {
    e.preventDefault();
    this.setState({
      phone: e.target.value,
      phoneErr: false  // Reset errore quando l'utente modifica il numero
    });
  }

  handleChangePhoneCode = (e) => {
    e.preventDefault();
    this.setState({
      phoneCode: e.target.value,
      phoneErr: false  // Reset errore quando l'utente modifica il prefisso
    });
  }

  alertResponse(info) {
    switch (info.type) {
      case "closeButton":
        this.setState({ inScreenPopupShow: false })
        break;
      case "actionButton":
        if (info.option1 === "attention")
          this.setState({ inScreenPopupShow: false })
        break;
      default:
        break;
    }
  }

  // Default browser alert function replacement
  handleAlert = (incomingMsg) => {
    this.setState({
      inScreenPopupShow: true,
      inScreenPopupMsg: incomingMsg,
    })
  }

  render() {

    const isDisabled = !this.canBeSubmitted();
    return (
      <Router>
        <div>
          <div>
            <BrowserView>
              <div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
                <div className="row flex-nowrap">
                  <div className="col-2 d-flex align-items-center">
                    {/*
												<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
											*/}
                  </div>
                  <div className="col-8 d-flex align-items-center justify-content-center">
                    <img className="sn_mobile_top_row_logo" src={logo} alt="" />
                  </div>
                  <div className="col-2 d-flex align-items-center justify-content-end">
                    <div className="sn_exit">
                      <a onClick={() => { this.props.history.goBack(); }}>
                        <img src={clos} alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="sn_topbar"><TopBar step={this.state.step} /></div>
              <div className="sn_overlay d-lg-none"></div>
              <div className="sn_editmail">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-lg-7 mx-auto">
                      <div className="sn_register__container">
                        <div className="row d-none d-lg-flex">
                          <div className="col-12 d-flex justify-content-end">
                            <div className="sn_exit">
                              <a onClick={() => { this.props.history.goBack(); }}>
                                <img src={clos} alt="" />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="row mb-4">
                          <div className="col-12">
                            <h3 className="text-center">{tr.t("ChangePhoneNumber")}</h3>
                            <p className="text-center">{tr.t("InsertPhoneNumber")}</p>
                            <div className="row mb-4 justify-content-center">
                              <div className="col-3">
                                <select
                                  name="Phone Code"
                                  className={(this.state.phoneErr) ? "err_red sn_input" : "err_no sn_input"}
                                  onChange={this.handleChangePhoneCode}
                                  value={this.state.phoneCode}
                                >
                                  {countryCodes.map((country) => (
                                    <option key={country.code} value={country.code}>
                                      {country.code} {country.country}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-6">
                                <input
                                  type="tel"
                                  spellCheck={false}
                                  name="Phone Number"
                                  placeholder={tr.t("PhoneNumber")}
                                  className={(this.state.phoneErr) ? "err_red sn_input" : "err_no sn_input"}
                                  maxLength="50" onChange={this.handleChangePhone} value={this.state.phone}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 d-flex justify-content-center justify-content-sm-end">
                            <button className="sn_btn" onClick={this.savePhoneNumber} disabled={isDisabled}>{tr.t("Save")}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </BrowserView>
            <MobileView>
              <div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
                <div className="row flex-nowrap">
                  <div className="col-2 d-flex align-items-center">
                    {/*
												<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
											*/}
                  </div>
                  <div className="col-8 d-flex align-items-center justify-content-center">
                    <img className="sn_mobile_top_row_logo" src={logo} alt="" />
                  </div>
                  <div className="col-2 d-flex align-items-center justify-content-end">
                    <div className="sn_exit">
                      <a onClick={() => { this.props.history.goBack(); }}>
                        <img src={clos} alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="sn_topbar"><TopBar step={this.state.step} /></div>
              <div className="sn_overlay d-lg-none"></div>
              <div className="sn_editmail">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-lg-7 mx-auto">
                      <div className="sn_register__container">
                        <div className="row d-none d-lg-flex">
                          <div className="col-12 d-flex justify-content-end">
                            <div className="sn_exit">
                              <a onClick={() => { this.props.history.goBack(); }}>
                                <img src={clos} alt="" />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="row mb-4">
                          <div className="col-12">
                            <h3 className="text-center">{tr.t("ChangePhoneNumber")}</h3>
                            <p className="text-center">{tr.t("InsertPhoneNumber")}</p>
                            <div className="row mb-3">
                              <div className="col-12">
                                <select
                                  name="Phone Code"
                                  className={(this.state.phoneErr) ? "err_red sn_input" : "err_no sn_input"}
                                  onChange={this.handleChangePhoneCode}
                                  value={this.state.phoneCode}
                                >
                                  {countryCodes.map((country) => (
                                    <option key={country.code} value={country.code}>
                                      {country.code} {country.country}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12">
                                <input
                                  type="tel"
                                  spellCheck={false}
                                  name="Phone Number"
                                  placeholder={tr.t("PhoneNumber")}
                                  className={(this.state.phoneErr) ? "err_red sn_input" : "err_no sn_input"}
                                  maxLength="50" onChange={this.handleChangePhone} value={this.state.phone}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 d-flex justify-content-center justify-content-sm-end">
                            <button className="sn_btn" onClick={this.savePhoneNumber} disabled={isDisabled}>{tr.t("Save")}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </MobileView>
          </div>
          {
            this.state.inScreenPopupShow ?
              <div className="containerModal">
                {
                  this.state.inScreenPopupShow ?
                    <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.inScreenPopupMsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
                }
              </div> : null
          }
        </div>
      </Router>
    );
  }
}

export default ChangePhone;


// WEBPACK FOOTER //
// ./src/screens/ChangePhone/ChangePhone.js